import * as T from '../types';

const resetPayState = () => (dispatch: any) => {
  dispatch({ type: T.PAY_REQUEST_RESET });
  dispatch({ type: T.PAY_POLLING_RESET });
};

export default resetPayState;
